var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseApi } from '../baseApi';
export default class AccountsApi extends BaseApi {
    constructor() {
        super(...arguments);
        this.apiBasePath = 'accounts';
        this.accountsManagementPath = 'accounts-management';
    }
    getAccounts(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'GET',
                route: `${this.apiBasePath}`,
                params: params,
            });
        });
    }
    createAccount(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'POST',
                route: `${this.apiBasePath}`,
                data,
            });
        });
    }
    updateAccount(id, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'PUT',
                route: `${this.apiBasePath}`,
                params: {
                    id: id,
                },
                data,
            });
        });
    }
    deleteAccount(id_1) {
        return __awaiter(this, arguments, void 0, function* (id, softDelete = true) {
            return yield this.apiCall({
                method: 'DELETE',
                route: `${this.apiBasePath}`,
                params: {
                    id: id,
                    softDelete: softDelete,
                },
            });
        });
    }
    getAccountsV2(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'GET',
                route: `v2/${this.apiBasePath}`,
                params: params,
            });
        });
    }
    listEnvironmentAccounts(environmentId, filters) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'GET',
                route: `${this.accountsManagementPath}/${environmentId}/list`,
                params: filters,
            });
        });
    }
    environmentAccount(environmentId, accountId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'GET',
                route: `${this.accountsManagementPath}/${environmentId}/account/${accountId}`,
            });
        });
    }
    environmentAccountData(environmentId, accountId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'GET',
                route: `${this.accountsManagementPath}/${environmentId}/account-data/${accountId}`,
            });
        });
    }
    updateEnvironmentAccountData(environmentId, accountId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'PUT',
                route: `${this.accountsManagementPath}/${environmentId}/account-data/${accountId}`,
                data,
            });
        });
    }
    createEnvironmentAccount(environmentId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'POST',
                route: `${this.accountsManagementPath}/${environmentId}/account`,
                data,
            });
        });
    }
    enableEnvironmentAccount(environmentId, accountId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'PUT',
                route: `${this.accountsManagementPath}/${environmentId}/account-enable/${accountId}`,
            });
        });
    }
    disableEnvironmentAccount(environmentId, accountId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.apiCall({
                method: 'PUT',
                route: `${this.accountsManagementPath}/${environmentId}/account-disable/${accountId}`,
            });
        });
    }
    syncAccounts() {
        return __awaiter(this, arguments, void 0, function* (data = {}) {
            return yield this.apiCall({
                method: 'POST',
                route: `${this.accountsManagementPath}/sync-accounts`,
                data,
            });
        });
    }
}
//# sourceMappingURL=index.js.map